// Polling (#512): what waits on a person reaches the bell, Today and Chat without a reload. Polling is enough; a page
// asks again every POLL_SECONDS while it is open, and not while the tab is hidden.
import { useEffect, useRef } from "react";

/** How often an open page asks again for what is new. */
export const POLL_SECONDS = 30;

/** Calls `refresh` every POLL_SECONDS while the component is mounted and the tab is visible. */
export function usePolling(refresh: () => void, seconds = POLL_SECONDS): void {
  const latest = useRef(refresh);
  latest.current = refresh;
  useEffect(() => {
    const timer = setInterval(() => {
      if (document.visibilityState !== "hidden") latest.current();
    }, seconds * 1000);
    return () => clearInterval(timer);
  }, [seconds]);
}
